export default __webpack_public_path__ + "static/media/vault.65ab04ee.svg";